import { get, put, post, del, default as com } from '@/common/api'
import patient from '@/components/patient/api'

let api = {
  /** ****************** 患者 ****************** **/
  getPatientByIdNo: com.getPatientByIdNo,
  /** ****************** 号别、挂号目标、时段列表 ****************** **/
  queryRegType: com.queryRegType,
  queryTarget(para) {
    return get('/api/op/regTarget', para)
  },
  queryPeriodList: com.queryPeriodList,
  /** ****************** 就诊号 ****************** **/
  queryAppointment:(para)=> {
    return get('/api/op/reg/all', para)
  },
  // 预约
  appointReg:(para)=> {
    return post('/api/op/reg/appointment', para)
  },
  cancelReg:(id)=> {
    return del(`/api/op/reg/appointment/${id}`)
  },
  // 查询预约范围
  getDateRange:(para)=> {
    return get('/api/op/regStatistic/appointmentDateRange', para)
  },
  // 查询余号
  queryRestReg:(para)=> {
    return get('/api/op/regStatistic/rest', para)
  },
}
export default api
